import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import RequireAdmin from './RequireAdmin';
import PromptPage from "../views/prompts";
import ChatPage from "../views/ai/ChatPage";
import MonitorPage from "../views/monitor";

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const UsersDefault = Loadable(lazy(() => import('views/users/Default')));
const ApplicationsList = Loadable(lazy(() => import('views/applications/ApplicationsList')));
const MySubscriptionsPage = Loadable(lazy(() => import('views/subscriptions')));

// utilities routing
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <RequireAdmin />,
  children: [
    {
      path: '/',
      element: <MainLayout />,
      children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'users',
      children: [
        {
          path: 'default',
          element: <UsersDefault />
        }
      ]
    },
    {
      path: 'applications',
      children: [
        {
          path: 'list',
          element: <ApplicationsList />
        }
      ]
    },
    {
      path: 'prompts/:id',
      element: <PromptPage />
    },
    {
      path: 'subscriptions',
      element: <MySubscriptionsPage />
    },
    {
      path: 'monitor',
      children: [
        {
          path: 'add',
          element: <MonitorPage />
        },
        {
          path: 'monitor/:id',
          element: <MonitorPage />
        }
      ]
    },
    {
      path: 'ai',
      children: [
        {
          path: 'chat/:id',
          element: <ChatPage />
        }
        ]
    },
    {
      path: 'utils',
      children: [
        {
          element: <UtilsColor />
        }
      ]
    },
    {
      path: 'utils',
      children: [
        {
          path: 'util-shadow',
          element: <UtilsShadow />
        }
      ]
    },
    {
      path: 'icons',
      children: [
        {
          path: 'tabler-icons',
          element: <UtilsTablerIcons />
        }
      ]
    },
    {
      path: 'icons',
      children: [
        {
          path: 'material-icons',
          element: <UtilsMaterialIcons />
        }
      ]
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    }
      ]
    }
  ]
};

export default MainRoutes;
